module.exports = "/images/blank-Pen.png?56477a47175b5186e821bf13f1b926a6";